import Joi from "joi-browser";

const ProfileModalSchema = {
  name: Joi.string()
    .regex(/^[A-Za-z ]+$/)
    .trim()
    .max(32)
    .label("name")
    .error((errors) =>
      errors.map((error) => {
        switch (error.type) {
          case "string.regex.base":
            return {
              message: "Numbers and Special characters are not allowed",
            };
          case "any.empty":
            return { message: `First Name is not allowed to be empty` };
          case "string.max":
            return {
              message: `First Name must be less than 32 characters long`,
            };
        }
      })
    ),

  email: Joi.string()
    .required()
    .email({ minDomainAtoms: 2 })
    .label("Email")
    .error((errors) =>
      errors.map((error) => {
        switch (error.type) {
          case "any.empty":
            return { message: "Email cannot be empty" };
          case "string.email":
            return { message: "Not correct email format" };
          default:
            return { message: `Unknown Error` };
        }
      })
    ),

  password: Joi.string()
    .min(6)
    .required()
    .label("Password")
    .error((errors) =>
      errors.map((error) => {
        switch (error.type) {
          case "any.empty":
            return { message: "Password cannot be empty" };
          case "string.min":
            return {
              message: "Password must be at least 6 characters long",
            };
          default:
            return { message: "Invalid password" };
        }
      })
    ),
};

export default ProfileModalSchema;
